<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'
import StyledDialogHeader from '@/components/layout/styled-dialog-header.vue'
import BookingStatusLabel from '@/components/booking/booking-status-label.vue'
import BookingStatusMap from '@/shared/constants/booking/BookingStatusMap'

export default {
  name: 'BookingPendingApprovalsDetailsDialogHeader',
  components: {
    StyledDialogHeader,
    BookingStatusLabel,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      isLoadingFlyout: 'bookingApprovals/isLoadingFlyout',
      flyoutHasError: 'bookingApprovals/flyoutHasError',
      activeBooking: 'bookingApprovals/activeBooking',
    }),
    compFlyoutTitle() {
      if (this.isLoadingFlyout) return 'Loading...'
      if (this.flyoutHasError) return ''
      return `REF#${this.activeBooking?.id}`
    },
    bookingStatus() {
      return BookingStatusMap[this.activeBooking?.status]
    },
  },
}
</script>

<template>
  <StyledDialogHeader
    :title="compFlyoutTitle"
    subtitle="Booking Request"
    description=" "
    @close="$emit('close')"
  >
    <template v-slot:actions>
      <BookingStatusLabel
        v-if="!isLoadingFlyout"
        :status="bookingStatus"
        class="mr-4"
      />
    </template>
  </StyledDialogHeader>
</template>
